import React from 'react'
import AssociatedTask from './AssociatedTask'

class AssociatedTasks extends React.Component {
   constructor(props) {
     super(props)
      this.state = {
        display_modal: {item_type: '', item_id: ''}
      }
    }

    handleTaskClick(task_type, task_id) {
      this.setState({display_modal: {item_type: task_type, item_id: task_id}});
    }

    addTOLeavePlan() {
      if (this.props.just_looking) {
        return this.props.handleJustLookingClick(true);
      } else {
        const timeline_ids = $.map(this.props.data.timeline_items, task => task.id);
        $.ajax({
          type: 'put',
          url: this.props.associationUrl,
          data: { id: this.props.data.id, timeline_items: timeline_ids },
          success: response => {
            if (response.status === 'success') {
              toastr.success('Successfully added to LeavePlan');
              return this.props.updateRecord(response.record);
            }
          }
        });
      }
    }

    _allTasksAdded() {
      const { timeline_items } = this.props.data;
      if (timeline_items) {
        let result;
        const data = $.map(timeline_items, item => item.added_to_leave_plan);
        return result = ($.inArray(false, data) === -1);
      }
    }

    buttonText() {
      if (this.props.just_looking) {
        return 'Activate LeavePlan';
      } else {
        return 'Add to LeavePlan';
      }
    }
    renderAssociatedTask() {
      return this.props.data.timeline_items.map((task, i) => {
        return (<AssociatedTask
          key={task.id}
          data={task}
          display_modal={this.state.display_modal}
          handleTaskClick={this.handleTaskClick.bind(this)}
          handleCheck={this.props.handleCheck}
          onHelpfulCheck={this.props.onHelpfulCheck}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
          isAddedToLeavePlan={this.props.data.added_to_leave_plan}/>
        )
      });
    }

    renderButton() {
      if (this.props.data.timeline_items.length === 0) {
        return null
      }
      if (this.props.data.added_to_leave_plan && this._allTasksAdded()) {
        return(<h4>Added to LeavePlan</h4>)
      } else {
        if (!this.props.isLeavePlanPartner) {
          return( 
            <button className='btn btn-darkgray btn-lg' onClick={this.addTOLeavePlan.bind(this)}>
              {this.buttonText()}
            </button>
          )
        }
      }
    }

    render() {
      return (
        <div className='associated-tasks'>
          <div className='timeline-items'>
            <h3>{ this.props.data.timeline_items.length > 0 ? "Related Tasks": '' }</h3>
            { this.renderAssociatedTask() }
            <div className='add-to-leaveplan pull-right'>
              { this.renderButton() }
            </div>
          </div>
        </div>
      );
    }
}

export default AssociatedTasks 
